export const calculateRateCostCompound = (
  amount: number,
  advance: number,
  rate: number,
  days: number,
) => {
  const amountFinanced = amount * (advance / 100);
  return (
    (amountFinanced * rate * days) / 30 / 100 / (1 + (rate * days) / 30 / 100)
  );
};
